import history from '../../../../../history'
import { Button, Text } from '../../../..'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { toggleAuthModal } from '../../../../../actions/homeSearchAuthModal'
import { selectClientIsGuest } from '../../../../../store/selectors/client'
import { setContactHomebotShowModal } from '../../../../../store/slices/contactHomebot'

export const MSG = defineMessages({
  contact: {
    id: 'ContactHomebotButton.cta',
    defaultMessage: 'Contact Homebot for info',
  },
})

export const ContactHomebotButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isGuest = useSelector(selectClientIsGuest)

  const handleContactClick = () => {
    if (isGuest) {
      history.push(`?redirectUrl=${window.location.href}`)
      dispatch(toggleAuthModal(true))
    } else {
      dispatch(setContactHomebotShowModal(true))
    }
  }

  return (
    <Button minimal onClick={handleContactClick}>
      <Text size='xs'>{intl.formatMessage(MSG.contact)}</Text>
    </Button>
  )
}
